import { render } from "./AddFoodModal.vue?vue&type=template&id=7450d48b&ts=true"
import script from "./AddFoodModal.vue?vue&type=script&lang=ts"
export * from "./AddFoodModal.vue?vue&type=script&lang=ts"

import "./AddFoodModal.vue?vue&type=style&index=0&id=7450d48b&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__